import React, { useState, useRef } from 'react'
import { useStyles } from './FilePickerStyle'

//Material UI
import AddIcon from '@material-ui/icons/Add'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary'
import IconButton from '@material-ui/core/IconButton'
import GetAppIcon from '@material-ui/icons/GetApp'
import DeleteIcon from '@material-ui/icons/Delete'

export default function FilePicker({ onChange, defaultValue, fileDownloadName, inputLabel, required }) {
  
  const classes = useStyles()

  const [FileLogo, setFileLogo] = useState(defaultValue ? PictureAsPdfIcon : AddIcon)
  const [fileURL, setFileURL] = useState(defaultValue)

  const fName = (defaultValue) ? fileDownloadName + '.' + defaultValue.split(';')[0].split('/')[1] : ''
  const [fileName, setFileName] = useState(fName)
  const inputRef = useRef(null)
  const [require, setRequire] = useState(defaultValue ? false : required)

  /**
   * File preview and error handling
   * for the file input
   * @param {*} e onchange event
   */
  async function fileUpdate(e) {
    setRequire(required)    
    
    const file = e.target.files[0]
    if (file === undefined) {
      setFileLogo(AddIcon)
      setFileName('')
      inputRef.current.value = null
      onChange('')
      return
    }

    let name = file.name
    let logo = ''

    if (file.type === 'application/pdf') logo = PictureAsPdfIcon
    else if (file.type.substring(0, 5) === 'image') logo = PhotoLibraryIcon
    else {
      console.log('type de fichier invalide')
      setFileLogo(AddIcon)
      setFileName('')
      inputRef.current.value = null
      onChange('')
      return
    }

    const fileBase64 = await fileToBase64(file)
    setFileLogo(logo)
    setFileName(name)
    onChange(fileBase64)
    setFileURL(fileBase64)
  }

  /**
   * Clear the fileInput
   */
  function deleteFile() {
    setFileLogo(AddIcon)
    setFileName('')
    inputRef.current.value = null
    setRequire(required)
    onChange('')
  }

  /**
   * Convert html file to base64 String
   * @param {*} file
   * @returns Promise => base64String
   */
  function fileToBase64(file) {
    return new Promise(res => {
      const fileReader = new FileReader()
      fileReader.onload = e => { res(e.target.result) }
      fileReader.onerror = err => { res({ err }) }
      fileReader.readAsDataURL(file)
    })
  }

  return (
    <div className={classes.filePicker}>
      <p>{inputLabel} {required ? '*' : ''}</p>
      <div className={classes.content}>
        <div className={classes.form}>
          <div>
            <input
              type="file"
              name="justificatif"
              accept=".pdf,image/*"
              onChange={fileUpdate}
              ref={inputRef}
              required={require}
            />
            <IconButton>{<FileLogo />}</IconButton>
          </div>
          <p>{fileName}</p>
        </div>
        {(fileDownloadName && FileLogo !== AddIcon) &&
          <div className={classes.actions}>
            <IconButton
              href={fileURL}
              target="_blank"
              download={fileDownloadName}
              color="primary"
              variant="contained"
              size="small"
            >
              <GetAppIcon fontSize="small" />
            </IconButton>
            <IconButton
              className={classes.delete}
              variant="contained"
              size="small"
              color="primary"
              onClick={deleteFile}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>
        }
      </div>

    </div>
  )
}
